export const CREATE_BUDGET = 'CREATE_BUDGET';
export const CREATED_BUDGET = 'CREATED_BUDGET';
export const CREATE_BUDGET_FAILED = 'CREATE_BUDGET_FAILED';
